import React from "react";
import styles from "../styles/Footer.module.css";

const Footer: React.FC = () => {
  return (
    <footer className={styles.footer}>
      <p>© 2025 VV Trips. All rights reserved.</p>
      <ul>
        <li>
          <a href="/privacy-policy">Privacy Policy</a>
        </li>
        <li>
          <a href="/terms-and-conditions">Terms & Conditions</a>
        </li>
        <li>
          <a href="/faq">FAQ</a>
        </li>
      </ul>
    </footer>
  );
};

export default Footer;
